<mat-nav-list class="" [ngClass]="divider?'nav__list':'nav-item'" [class.nav-item--primary]="color === 'primary'" [class.nav-item--collapsed]="collapsed">
  <ng-container *ngFor="let menuItem of menuList">
    <ng-container [ngTemplateOutlet]="menuItem.subMenu ?  menu : item" [ngTemplateOutletContext]="{menuItem:menuItem}"></ng-container>
  </ng-container>
</mat-nav-list>

<ng-template #item let-menuItem="menuItem" let-itemPanel="itemPanel">
  <mat-divider *ngIf="divider && menuItem.isVisible" class="mb-0 text-100"></mat-divider>
  <a
    *ngIf="menuItem.path && menuItem.isVisible"
    mat-list-item
    [routerLink]="'/' + menuItem.path"
    routerLinkActive="active-item"
    [routerLinkActiveOptions]="{exact: false}"
    [class.rtl]="layoutService.websiteDirection$.value === 'rtl'"
    [matTooltip]="tooltipText(menuItem)"
    [matTooltipDisabled]="!collapsed"
    matTooltipPosition="after"
    matTooltipClass="nav-tooltip"
    (mouseenter)="collapsed && closeAllPopovers()"
  >
    <div class="flex align-center">
      <app-icon *ngIf="menuItem.icon" class="d-inline-block align-center" size="xs" [name]="menuItem.icon"></app-icon>
      <div [class.collapsed]="collapsed"  [ngClass]="divider?'ml-2 my-0 small':'ml-4 nav-item__title'" *ngIf="!htmlItemsMap[menuItem.title]">{{menuItem.title}}</div>
      <div
        [class.collapsed]="collapsed"
        [ngClass]="divider?'ml-2 my-0 small':'ml-4 nav-item__title'"class="nav__list-lh py-1" 
        *ngIf="htmlItemsMap[menuItem.title]"
        [innerHTML]="htmlItemsMap[menuItem.title]"
      ></div>
    </div>
  </a>
  <mat-list-item
    *ngIf="!menuItem.path && menuItem.isVisible"
    [class.rtl]="layoutService.websiteDirection$.value === 'rtl'"
    [matTooltip]="tooltipText(menuItem)"
    [matTooltipDisabled]="!collapsed"
    matTooltipPosition="after"
    matTooltipClass="nav-tooltip"
    (mouseenter)="collapsed && closeAllPopovers()"
    (click)="action.emit(menuItem.action)"
  >
    <div class="flex align-center nav-item__title ">
      <app-icon *ngIf="menuItem.icon" class="d-inline-block align-center" size="xs" [name]="menuItem.icon"></app-icon>
      <div [class.collapsed]="collapsed" [ngClass]="divider?'ml-2 my-0 small':'ml-4'">{{menuItem.title}}</div>
    </div>
  </mat-list-item>
  <mat-divider *ngIf="divider && menuItem.isVisible" class="text-100"></mat-divider>
</ng-template>

<ng-template #menu let-menuItem="menuItem" hideToggle="true" #example>
  <mat-divider *ngIf="divider && menuItem.isVisible" class="mb-0 text-100"></mat-divider>
  <mat-expansion-panel *ngIf="menuItem.isVisible" #panel [class.mat-elevation-z0]="true" [class.collaps]="collapsed" hideToggle="true">
    <mat-expansion-panel-header
      [popoverTrigger]="collapsed ? popover : null"
      #popoverInstance="popoverTrigger"
      [closeOnClickOutside]="true"
      [position]="position"
      [mouseOnHover]="true"
      [width]="'auto'"
      [backDrop]="false"
      [class.nav-item__parent-active]="collapsed && activeParents.has(menuItem)"
      (click)="stopPropagation($event)"
      (mouseenter)="handleOpenPopover(popoverInstance)"
    >
      <div class="flex align-center nav-item__title">
        <app-icon *ngIf="menuItem.icon" class="d-inline align-center" size="xs" [name]="menuItem.icon"></app-icon>
        <div [class.collapsed]="collapsed" [ngClass]="divider?'ml-2 my-0 small':'ml-4'">{{menuItem.title}}</div>
      </div>

      <div class="ml-auto" *ngIf="!collapsed">
        <app-icon name="outline-arrow-up" class="d-inline align-center" size="xs" *ngIf="panel.expanded"></app-icon>
        <app-icon name="outline-arrow-down" class="d-inline align-center" size="xs" *ngIf="!panel.expanded"></app-icon>
      </div>
    </mat-expansion-panel-header>

    <!-- Collapsed rail: the submodules open in a flyout beside the parent icon. -->
    <ng-template #popover>
      <div class="nav-flyout" (click)="popoverInstance.close()">
        <p class="nav-flyout__title">{{ menuItem.title }}</p>
        <div class="nav-flyout__divider"></div>
        <div class="nav-flyout__items">
          <ng-container *ngFor="let submenu of menuItem.subMenu">
            <a
              *ngIf="submenu.path && submenu.isVisible"
              class="nav-flyout__item"
              [routerLink]="'/' + submenu.path"
              routerLinkActive="nav-flyout__item--active"
              [routerLinkActiveOptions]="{exact: false}"
              #flyoutLink="routerLinkActive"
            >
              <span *ngIf="flyoutLink.isActive" class="nav-flyout__dot"></span>
              <span>{{ submenu.title }}</span>
            </a>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <mat-nav-list *ngIf="!collapsed">
      <ng-container
        *ngFor="let submenu of menuItem.subMenu"
        [ngTemplateOutlet]="submenu.subMenu ?  menu : item"
        [ngTemplateOutletContext]="{menuItem:submenu}"
      ></ng-container>
    </mat-nav-list>
  </mat-expansion-panel>
  <mat-divider *ngIf="divider && menuItem.isVisible" class="text-100"></mat-divider>
</ng-template>
